module.exports = __webpack_public_path__ + "img/cluster-manager.8dadbbdd.png";